module.exports = global["IBAN"] = require("-!.\\iban.js");


//////////////////
// WEBPACK FOOTER
// ./~/iban/iban.js-exposed
// module id = 653
// module chunks = 7